import type { CSWState } from './types';

/**
 * Calcola lo stato della Customer Service Window (CSW 24h + FEP 72h) dai timestamp DB.
 *
 * Funzione PURA, senza dipendenze runtime (niente supabase/DOM) → testabile in ambiente
 * node. Estratta da CloudProvider così i test non trascinano il client supabase
 * (che al load tocca `window`).
 */
export function computeCSWState(cswExpiresAt: string | null, fepExpiresAt: string | null, nowMs: number = Date.now()): CSWState {
  const csw = cswExpiresAt ? new Date(cswExpiresAt) : null;
  const fep = fepExpiresAt ? new Date(fepExpiresAt) : null;
  const now = nowMs;
  const cswOpen = csw ? csw.getTime() > now : false;
  const fepOpen = fep ? fep.getTime() > now : false;
  const isOpen = cswOpen || fepOpen;
  let minutesRemaining: number | null = null;
  if (isOpen) {
    const ms = Math.max(
      cswOpen && csw ? csw.getTime() - now : 0,
      fepOpen && fep ? fep.getTime() - now : 0,
    );
    minutesRemaining = Math.ceil(ms / 60_000);
  }
  return { cswExpiresAt: csw, fepExpiresAt: fep, isOpen, minutesRemaining };
}
